import { Address, VehicleId } from '../../sharedComponents/common.types';
import { ServiceOrderVehicleModel, ServiceType } from '../shared/commonServiceOrder.types';
import { AccessoryType, CollectedAccessories } from './accessory.types';

export enum ServiceOrderStatus {
    OPEN = 'open',
    COMPLETED = 'completed',
    CANCELLED = 'cancelled',
}

export type ServiceOrderPage = {
    readonly items: ServiceOrder[];
    readonly hasMore: boolean;
};

export type ServiceOrderVehicle = {
    readonly id: VehicleId;
    readonly requestedAccessories: AccessoryType[];
    readonly model?: ServiceOrderVehicleModel;
    readonly collectedAccessories?: CollectedAccessories;
};

export type Location = {
    readonly timeZone: string;
    readonly identifier?: string;
    readonly address?: Partial<Address>;
};

export type ServiceOrder = {
    readonly id: string;
    readonly externalOrderId: string;
    readonly vehicle: ServiceOrderVehicle;
    readonly status: ServiceOrderStatus;
    readonly type: ServiceType;
    readonly serviceLocation: Location;
    readonly startedAt?: Date;
    readonly completedAt?: Date;
    readonly orderIssuedAt: Date;
    readonly generalInformation?: string;
    readonly description?: string;
    readonly hasUnacknowledgedExternalChanges: boolean;
    readonly isFinalized: boolean;
    readonly isArchived: boolean;
    readonly externalOptionId?: string;
};

export enum ServiceOrderBulkUpdatePreviewErrorCode {
    UNKNOWN_ORDER = 'unknownOrder',
    UNSUPPORTED_ORDER_TYPE = 'unsupportedOrderType',
    CANCELLED = 'cancelled',
    FINALIZED = 'finalized',
    OTHER_SUPPLIER = 'otherSupplier',
}

export type ServiceOrderBulkUpdatePreviewError = {
    readonly errorCode: ServiceOrderBulkUpdatePreviewErrorCode;
    readonly orderIds: string[];
};

export type ServiceOrderBulkUpdatePreview = {
    readonly serviceOrders: ServiceOrderPreview[];
    readonly invalidOrders: ServiceOrderBulkUpdatePreviewError[];
};

export type ServiceOrderPreview = {
    readonly orderId: string;
    readonly startedAt?: Date;
    readonly completedAt?: Date;
    readonly timeZone: string;
    readonly generalInformation?: string;
};

export type ServiceOrderBulkUpdatePreviewResult =
    | ({ readonly success: true } & ServiceOrderBulkUpdatePreview)
    | { readonly success: false; readonly errorCode: 'size-exceeded' };
